import { TableRow as TableRowToExtend } from '@tiptap/extension-table-row';

export const TableRow = TableRowToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            },
            style: {
                default: null
            }
        }
    }
})
